import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import SearchPageContent from "./searchContent";
import { FiltersProvider } from "./filter.context";

init({
  debug: true,
  visualDebug: true,
  rtl: true,
});

export default function SpitialSearch() {

  return (
    <div className="legacy-app-shell">
      <FiltersProvider>
        <div className="legacy-app-shell-sidebar">
          <Menu focusKey="MENU" />
        </div>
        <div className="legacy-app-shell-content">
          <SearchPageContent />
        </div>
      </FiltersProvider>
    </div>
  );
}

